import Icon from "./Icon";
import * as React from "react";
function Spinner(props) {
    return (React.createElement(Icon, { className: props.className, name: "spinner_new", style: props.style, spin: true }));
}
export default Spinner;
